import.meta.glob('../images/**/*', { eager: true, query: '?url', import: 'default' });

import '../stylesheets/tailwind.css';

import setupTracking from '../lib/cta_tracking';
import { initBraze } from '../lib/braze';
import { readMeta } from '../lib/jwt_helper';
import * as growthbook from '../lib/growthbook';

setupTracking();

// Initialize Braze SDK
initBraze().catch((error) => {
  console.error('Failed to initialize Braze:', error);
});

// if analytics is loaded or we are in development mode, initialize growthbook
if (window.analytics || readMeta('rails-env')?.toLowerCase() === 'development') {
  growthbook.initGrowthbook();
} else {
  window.addEventListener('segmentLoaded', growthbook.initGrowthbook);
}
